import { RootState } from 'renderer/shared/state/store';

export const selectTransactionQuery = (state: RootState) => state.transaction;
